import { ExtratoDeRecebimentos } from '../../../../pkw-data/collect/extrato/extrato-de-recebimentos.model'
import { ChartPeriodoOptions } from './chart-periodo-options'

export class ChartRecebimentosOptions extends ChartPeriodoOptions {
    constructor(extrato: ExtratoDeRecebimentos, descricaoPeriodo: string) {
        super(extrato, `Quanto recebi no ${descricaoPeriodo.toLowerCase()}`)
    }

    obterSeries(): { name: string; data: number[] }[] {
        if (!this.extrato) {
            return []
        }

        return this.extrato.agrupamentos.map(agrupamento => {
            return {
                name: agrupamento.operadora.nome,
                data: this.xAxis.categories.map(
                    categoria =>
                        categoria === agrupamento.operadora.nome
                            ? agrupamento.transacao.valorLiquido
                            : null
                )
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/extratos/dashboard-extratos/vendas-recebimentos/shared/chart-recebimentos-options.ts